// Material Symbols Outlined (weight 400) inline SVGs. Add an icon by importing it here and listing it in `registry`.
// Icons render with currentColor and size from the surrounding font-size (see .icon in styles.css).
import dashboard from '@material-symbols/svg-400/outlined/dashboard.svg?raw';
import calendarMonth from '@material-symbols/svg-400/outlined/calendar_month.svg?raw';
import taskAlt from '@material-symbols/svg-400/outlined/task_alt.svg?raw';
import notifications from '@material-symbols/svg-400/outlined/notifications.svg?raw';
import notificationsActive from '@material-symbols/svg-400/outlined/notifications_active.svg?raw';
import home from '@material-symbols/svg-400/outlined/home.svg?raw';
import apartment from '@material-symbols/svg-400/outlined/apartment.svg?raw';
import analytics from '@material-symbols/svg-400/outlined/analytics.svg?raw';
import apps from '@material-symbols/svg-400/outlined/apps.svg?raw';
import settings from '@material-symbols/svg-400/outlined/settings.svg?raw';
import tv from '@material-symbols/svg-400/outlined/tv.svg?raw';
import logout from '@material-symbols/svg-400/outlined/logout.svg?raw';
import login from '@material-symbols/svg-400/outlined/login.svg?raw';
import schedule from '@material-symbols/svg-400/outlined/schedule.svg?raw';
import cleaningServices from '@material-symbols/svg-400/outlined/cleaning_services.svg?raw';
import chatBubble from '@material-symbols/svg-400/outlined/chat_bubble.svg?raw';
import event from '@material-symbols/svg-400/outlined/event.svg?raw';
import star from '@material-symbols/svg-400/outlined/star.svg?raw';
import info from '@material-symbols/svg-400/outlined/info.svg?raw';
import wbSunny from '@material-symbols/svg-400/outlined/wb_sunny.svg?raw';
import partlyCloudyDay from '@material-symbols/svg-400/outlined/partly_cloudy_day.svg?raw';
import cloud from '@material-symbols/svg-400/outlined/cloud.svg?raw';
import rainy from '@material-symbols/svg-400/outlined/rainy.svg?raw';
import thunderstorm from '@material-symbols/svg-400/outlined/thunderstorm.svg?raw';
import weatherSnowy from '@material-symbols/svg-400/outlined/weather_snowy.svg?raw';
import foggy from '@material-symbols/svg-400/outlined/foggy.svg?raw';
import bedtime from '@material-symbols/svg-400/outlined/bedtime.svg?raw';
import lock from '@material-symbols/svg-400/outlined/lock.svg?raw';
import lockOpen from '@material-symbols/svg-400/outlined/lock_open.svg?raw';
import thermostat from '@material-symbols/svg-400/outlined/thermostat.svg?raw';
import humidityPercentage from '@material-symbols/svg-400/outlined/humidity_percentage.svg?raw';
import batteryFull from '@material-symbols/svg-400/outlined/battery_full.svg?raw';
import batteryAlert from '@material-symbols/svg-400/outlined/battery_alert.svg?raw';
import cloudOff from '@material-symbols/svg-400/outlined/cloud_off.svg?raw';
import donutLarge from '@material-symbols/svg-400/outlined/donut_large.svg?raw';
import checkCircle from '@material-symbols/svg-400/outlined/check_circle.svg?raw';
import warning from '@material-symbols/svg-400/outlined/warning.svg?raw';
import chevronLeft from '@material-symbols/svg-400/outlined/chevron_left.svg?raw';
import chevronRight from '@material-symbols/svg-400/outlined/chevron_right.svg?raw';
import keyboardArrowDown from '@material-symbols/svg-400/outlined/keyboard_arrow_down.svg?raw';
import menu from '@material-symbols/svg-400/outlined/menu.svg?raw';
import arrowUpward from '@material-symbols/svg-400/outlined/arrow_upward.svg?raw';
import arrowDownward from '@material-symbols/svg-400/outlined/arrow_downward.svg?raw';
import openInNew from '@material-symbols/svg-400/outlined/open_in_new.svg?raw';
import volumeUp from '@material-symbols/svg-400/outlined/volume_up.svg?raw';
import volumeOff from '@material-symbols/svg-400/outlined/volume_off.svg?raw';
import gridView from '@material-symbols/svg-400/outlined/grid_view.svg?raw';
import hotel from '@material-symbols/svg-400/outlined/hotel.svg?raw';
import bed from '@material-symbols/svg-400/outlined/bed.svg?raw';
import arrowForward from '@material-symbols/svg-400/outlined/arrow_forward.svg?raw';
import trendingUp from '@material-symbols/svg-400/outlined/trending_up.svg?raw';
import syncAlt from '@material-symbols/svg-400/outlined/sync_alt.svg?raw';

export const registry = {
  dashboard: dashboard,
  calendar_month: calendarMonth,
  task_alt: taskAlt,
  notifications: notifications,
  notifications_active: notificationsActive,
  home: home,
  apartment: apartment,
  analytics: analytics,
  apps: apps,
  settings: settings,
  tv: tv,
  logout: logout,
  login: login,
  schedule: schedule,
  cleaning_services: cleaningServices,
  chat_bubble: chatBubble,
  event: event,
  star: star,
  info: info,
  wb_sunny: wbSunny,
  partly_cloudy_day: partlyCloudyDay,
  cloud: cloud,
  rainy: rainy,
  thunderstorm: thunderstorm,
  weather_snowy: weatherSnowy,
  foggy: foggy,
  bedtime: bedtime,
  lock: lock,
  lock_open: lockOpen,
  thermostat: thermostat,
  humidity_percentage: humidityPercentage,
  battery_full: batteryFull,
  battery_alert: batteryAlert,
  cloud_off: cloudOff,
  donut_large: donutLarge,
  check_circle: checkCircle,
  warning: warning,
  chevron_left: chevronLeft,
  chevron_right: chevronRight,
  keyboard_arrow_down: keyboardArrowDown,
  menu: menu,
  arrow_upward: arrowUpward,
  arrow_downward: arrowDownward,
  open_in_new: openInNew,
  volume_up: volumeUp,
  volume_off: volumeOff,
  grid_view: gridView,
  hotel: hotel,
  bed: bed,
  sync_alt: syncAlt,
  arrow_forward: arrowForward,
  trending_up: trendingUp,
};
